import React, { useState, useEffect } from "react";
import "./calendar-styles.css";
import "../theme/app-styles.css"


import { caretBack } from "ionicons/icons";
import Footer from "../components/Footer";

import {
  IonContent,
  IonPage,
  IonLabel,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,

} from "@ionic/react";



const BUTTON_URL: string[] = ["https://www.dropbox.com/scl/fi/lvdsytxgfftsgfkhe5mm4/SessionsCalendar-semester-2.xlsx?rlkey=qoze4gtouwi92xgg0pcdplcbb&st=2mnupijj&dl=0",
 "https://www.dropbox.com/scl/fi/dh358um74s52mafp2pqbv/litCal1.pdf?rlkey=rx7auguiwcp1k58huc8v8pnyl&st=5hm4ih61&dl=0"
];

//const BUTTON_NAME = ["Session Calendar", "Full Initiation Calendar", "Full Communion Calendar", "Complete Sacraments Calendar"];


const Calendars: React.FC = () => {
  const [calendarIndex, setCalendarIndex] = useState(4);


  useEffect(() => {
    if ((calendarIndex >= 0) && (calendarIndex <= 3)) {
      const myurl = new URL(BUTTON_URL[calendarIndex]);
      window.location.assign(myurl);
    }
  }, [calendarIndex]);

  

  return (
    <IonPage className="info-page">
      <IonHeader>
        <IonToolbar color="primary">
        <IonButtons slot="start">
            <IonBackButton defaultHref="/"   className="back-button" icon= {caretBack} text="">

            </IonBackButton>
    
          </IonButtons>
          <IonTitle className="ion-text-center">Calendars</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="background-image">
      <section>
        <div className="calendar-content-container">
          <div className="calendar-back-instructions">
            [Note: Press browser back button to return to this page.]
          </div>
          <div className="label-container">
          <IonLabel className="label">
          Catechectical Track Calendar:
          </IonLabel>
          <p>Calendar will be posted on July 21st.</p>
          </div>
       
          <div className="label-container">
          <IonLabel className="label">
              Liturgical Track Calendar:
         </IonLabel>
         <p>Calendar will be posted on July 21st.</p>

          </div>

   

       
       <Footer />
        </div>

      </section>

      </IonContent>
    </IonPage>
  );
};

export default Calendars;
